import { render, staticRenderFns } from "./primaryOrder.vue?vue&type=template&id=65371cdc&scoped=true"
import script from "./primaryOrder.vue?vue&type=script&lang=js"
export * from "./primaryOrder.vue?vue&type=script&lang=js"
import style0 from "./primaryOrder.vue?vue&type=style&index=0&id=65371cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65371cdc",
  null
  
)

export default component.exports